/**
 * Copyright IBM Corp. 2021
 *
 * This source code is licensed under the IBM Public License Version 1.0 found in the
 * LICENSE file in the root directory of this source tree.
 */

import "./matchMediaMock";
import "./FontFaceMock";
import fetch, { Request } from "node-fetch";
import dotenv from "dotenv";
import { TriModel } from "../TriModel";
import { setTriAppConfig, TriLoginApi } from "../";

let JSESSIONID = null;

export async function initTestEnv() {
  dotenv.config();
  global.fetch = (...fetchArgs) => {
    if (JSESSIONID != null && fetchArgs[0] instanceof Request) {
      fetchArgs[0].headers.set("Cookie", JSESSIONID);
    }
    return fetch(...fetchArgs);
  };
  global.Request = Request;

  setTriAppConfig({
    tririgaUrl: process.env.TRIRIGA_URL,
  });

  await loginIntoTririga();
}

async function loginIntoTririga() {
  const username = process.env.TRIRIGA_USER;
  const password = process.env.TRIRIGA_PASSWORD;
  const { loginResponse } = await TriLoginApi.login(username, password, false);
  const setCookies = loginResponse.headers.raw()["set-cookie"];
  JSESSIONID = setCookies.find((item) => item.indexOf("JSESSIONID=") >= 0);
  JSESSIONID = JSESSIONID.split(";")[0];
}

let appModel = null;

export async function getTestModel() {
  if (appModel != null) {
    return appModel;
  }
  const modelAndView = process.env.MODEL_AND_VIEW;
  const instanceId = process.env.INSTANCE_ID;
  return (appModel = new TriModel(modelAndView, instanceId, onError));
}

function onError(error) {
  console.log(error);
}
